export const onClientEntry = async () => {
  if (typeof IntersectionObserver === 'undefined') {
    await import('intersection-observer')
  }

  if (!('scrollBehavior' in document.documentElement.style)) {
    const smoothscroll = await import('smoothscroll-polyfill')
    smoothscroll.default.polyfill()
  }

  if (!window.CSS || !CSS.supports('color', 'var(--fake-var)')) {
    const cssVars = await import('css-vars-ponyfill')

    cssVars.default({
      watch: true,
    })
  }
}

export const onPreRouteUpdate = ({ prevLocation }) => {
  // Do full page refresh on IE11 to make CSS vars ponyfill work. Yes, this is awful
  if ((!window.CSS || !CSS.supports('color', 'var(--fake-var)')) && prevLocation) {
    location.href = prevLocation.href
  }
}
